import PropertiesMap from "./PropertiesMap";

export const propertiesMap = {
    init: (store) => {
        const els = document.querySelectorAll(".hotelDisplayView");
        [...els].forEach((mapEl) => new PropertiesMap(mapEl, store));
    },
};

export default propertiesMap;